var map = {
	"./audio-placeholder": 639,
	"./audio-placeholder.png": 639,
	"./avatar-missing": 456,
	"./avatar-missing.png": 456,
	"./avatar-missing.svg": 820,
	"./header-missing": 461,
	"./header-missing.png": 461,
	"./soapbox-logo": 462,
	"./soapbox-logo-white": 463,
	"./soapbox-logo-white.svg": 463,
	"./soapbox-logo.svg": 462,
	"./video-placeholder": 640,
	"./video-placeholder.png": 640,
	"./void": 641,
	"./void.png": 641,
	"./web-push/web-push-icon_expand": 714,
	"./web-push/web-push-icon_expand.png": 714,
	"./web-push/web-push-icon_favourite": 715,
	"./web-push/web-push-icon_favourite.png": 715,
	"./web-push/web-push-icon_reblog": 716,
	"./web-push/web-push-icon_reblog.png": 716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 819;